"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Tag = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const Typography_1 = require("../Typography/Typography");
exports.Tag = native_1.default.View `
  text-align: center;
  border-color: ${({ color }) => color};
  background-color: ${({ filled, color }) => (filled ? color : 'transparent')};
  border-width: 2px;
  border-radius: 12px;
  padding: 2px 4px;
`;
exports.Text = native_1.default(Typography_1.PText) `
  color: ${({ textColor }) => textColor};
  letter-spacing: 1.8px;
  font-size: 10px;
`;
